import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UploadFilesService {
  constructor() {}

  uploadFiles(files: File) {
    const formData = new FormData();
    formData.append('file', files);
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }
}
